module.exports = __webpack_public_path__ + "img/225deg.5fe3ed9a.svg";